import { useEffect } from "react";

import useFinanceDataContext from "features/vehicleDetails/providers/financeData/useFinanceDataContext";
import type { PartExchange } from "services/motorpoint/partExchange";
import type { PartExchangeQuestionAnswersResponse } from "services/motorpoint/partExchangeQuestions";
import generateGtmFinanceSubmitEvent from "utils/generateGtmFinanceSubmitEvent";

const useCalculateForDefault = (
    formData: any,
    partExQuestionsAnswersResponse:
        | PartExchangeQuestionAnswersResponse.AnswersResponse
        | PartExchange
        | undefined
) => {
    const { getFinanceData } = useFinanceDataContext();

    useEffect(() => {
        const { depositFromFinanceWidget, ...data } = formData;
        const params = {
            ...data,
            selectedFinanceType: formData.isHP ? "HP" : "PCP",
            preferredDepositAmount: !!partExQuestionsAnswersResponse
                ? 0
                : (depositFromFinanceWidget ?? formData.preferredDepositAmount),
        };

        params.isHP = null;

        getFinanceData(params);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [partExQuestionsAnswersResponse]);
};

export default useCalculateForDefault;
